(function () {
	'use strict';

	angular.module('smb-app')
		.directive('smbContent',[ContentDirective])
		.controller('ContentTypesController',
		[
			'$scope',
			'$state',
			'gettextCatalog',
			'pxProgressService',
			'sbToastService',
			'smbEnvironmentService',
			'smbToolbarService',
			'smbContentUploadDataStore',
			'smbIndexTypesDataStore',
			'smbContentTypeGroupConfigDataStore',
			'smbContentTypeConfigDataStore',
			'smbIconTypes',
			'smbDocumentViewerNavigationService',
			ContentController
		]);

	var templateUrl = require('./contentUpload.template');
	function ContentDirective() {
		return {
			restrict: 'E',
			controller: ContentController,
			controllerAs: 'vm',
			templateUrl: templateUrl,
			bindToController: {
				contentTypeGroupId: '@',
				contentTypeId: '@'
			},
			scope: {}
		};
	}

	function ContentController($scope, $state, gettextCatalog, pxProgressService, sbToastService, smbEnvironmentService, smbToolbarService,
		smbContentUploadDataStore, smbIndexTypesDataStore, smbContentTypeGroupConfigDataStore, smbContentTypeConfigDataStore, smbIconTypes,
		smbDocumentViewerNavigationService) {

		smbToolbarService.set(gettextCatalog.getString('Add Document'), 'import.contentTypeGroups.contentTypes');

		var vm = this;
		vm.defaultIconType = smbIconTypes[smbIconTypes.SVG];

		vm.uploadDS = smbContentUploadDataStore;
		vm.indexTypesDS = smbIndexTypesDataStore;
		vm.contentTypeDS = smbContentTypeConfigDataStore;
		vm.contentTypeGroupDS = smbContentTypeGroupConfigDataStore;
		vm.filename = null;
		vm.file = null;
		vm.onFileInputClick = onFileInputClick;

		vm.indexFileChanged = indexFileChanged;
		vm.upload = upload;

		function indexFileChanged(fileInput) {
			if (fileInput.files.length === 0) {
				return;
			}
			vm.filename = fileInput.files[0].name;
			vm.file = fileInput.files[0];
			$scope.$digest(); // probably not the best way, but this seemed to fix the problem of not updating label right away
		}

		vm.contentTypeGroupDS.getContentTypeGroup(vm.contentTypeGroupId)
			.then(function () {
				vm.contentTypeDS.getContentType(vm.contentTypeGroupId, vm.contentTypeId);
			})
			.then(function () {
				vm.indexTypesDS.getIndexTypes(vm.contentTypeId);
			});

		function upload() {
			if (vm.file) {
				vm.uploadDS.uploadDocument(vm.contentTypeId, vm.file)
				.then(function indexTypesUpload() {
					vm.indexTypesDS.setIndexTypes(vm.indexTypesDS.indexTypes, vm.uploadDS.uploadedDocument.data.DocumentId, vm.contentTypeId)
					.then(function() {
						sbToastService.showSimple(gettextCatalog.getString('Document Uploaded Successfully'));
					}).then(function openViewer() {
						smbDocumentViewerNavigationService.go(vm.contentTypeGroupId, vm.contentTypeId, vm.uploadDS.uploadedDocument.data.DocumentId);
					});
				});
			}
			else {
				sbToastService.showSimple(gettextCatalog.getString('Please select a file to upload'));
			}
		}

		function onFileInputClick(ev) {
			// If running in IE or Firefox, need to programatically trigger the input file.
			// Unlike Chrome, when embedding a file input in a button, clicking
			// the button doesn't trigger the file input.
			if (smbEnvironmentService.isIE || smbEnvironmentService.isFireFox) {
				var fileInput = ev.target.querySelector('input[type="file"]');
				if (fileInput) {
					fileInput.click();
				}
			}
		}
	}
}());


//////////////////
// WEBPACK FOOTER
// ./app/components/contentUpload/contentUpload.js
// module id = 78
// module chunks = 1